<template>
  <div
    @click="handleClick"
    class="product-item"
  >
    <div class="product-item-thumbnail">
      <Image
        class="product-item-thumbnail__image"
        :src="item.imageUrl"
        alt=""
        lazy
      />
      <div
        class="product-item__translate"
        @click="(e) => translateFun(item, e)"
      >
        Translate
      </div>
      <div
        class="product-item-buttons"
      >
        <!-- <div
          class="product-item-button product-item-button__discovery"
          @click="(e) => aiDiscovery(item, e)"
        >
          AI Discovery
        </div> -->
        <div
          class="product-item-button product-item-button__similar"
          @click="(e) => findSimilar(item, e)"
        >
          Find Similar
        </div>
      </div>
    </div>
    <div
      v-if="item?.monthSold > 1000 && [2, 5, 8].includes(item?.monthSold % 10)"
      class="product-item__bestseller"
    >
      Bestseller
    </div>

    <div class="product-item-content">
      <div class="product-item__title">
        {{ item?.subjectTrans }}
      </div>
      <div class="product-item__price">
        <IntlCurrency
          :currency="currencyData?.targetCurrency"
        />
        <span>{{ productPrice(item) }}</span>
      </div>
      <div
        class="product-item__shipping"
        v-if="showUnderShipping"
      >
        Shipping Under $3
      </div>
      <div
        class="product-item__order"
        v-else
      >
        {{ item?.minOrderQuantity ? `Min. order: ${item?.minOrderQuantity} pieces` : '' }}
      </div>
      <div
        v-if="item?.sellerDataInfo?.compositeServiceScore > 0 || item?.monthSold"
        class="product-item__scores"
      >
        <template v-if="item?.sellerDataInfo?.compositeServiceScore > 0">
          <Rate
            class="product-item__rate"
            :value="item.sellerDataInfo.compositeServiceScore"
          />
          <p
            class="product-item__score"
          >
            {{ Number(item.sellerDataInfo.compositeServiceScore).toFixed(1) }}
          </p>
        </template>
        <div
          v-if="item?.sellerDataInfo?.compositeServiceScore > 0 && item?.monthSold"
          class="product-item__divider"
        />
        <p
          class="product-item__sold"
          v-if="item?.monthSold"
        >
          <Icon
            v-if="!(item?.sellerDataInfo?.compositeServiceScore > 0)"
            class="product-item__hot"
            :class="{
              'product-item__hot--active': item?.monthSold > 1000
            }"
            name="hot"
          />
          {{ formatSalesVolume(item.monthSold) }} sold
        </p>
      </div>
      <p
        class="product-item__adding"
        v-if="item?.monthSold > 300 && item?.sellerDataInfo?.repeatPurchasePercent > 0.6 && [2, 3, 6, 7].includes(item.monthSold % 10)"
      >
        <!-- 随机从[10, 50]中取个数字 -->
        <span>{{ addingCount }}</span> adding to cart
      </p>
      <p
        class="product-item__favorite"
        v-else-if="item?.sellerDataInfo?.repeatPurchasePercent"
      >
        Customer reorder rate {{ (item.sellerDataInfo.repeatPurchasePercent * 100).toFixed(0) }}%
      </p>
      <div
        class="product-item-hover"
        v-if="showMainHover(item)"
      >
        <div class="product-item-hover__title">
          Supplier Credit Rating
        </div>
        <div class="product-item-hover__score">
          <Rate
            class="product-item-hover__stars"
            :value="item.sellerDataInfo.compositeServiceScore"
          />
          <div>
            ({{ item?.sellerDataInfo?.compositeServiceScore }})
          </div>
        </div>
        <div class="product-item-hover-cell">
          <div>
            Trade Medal Level
          </div>
          <div class="product-item-hover-cell__divider" />
          <div>
            ({{ item?.sellerDataInfo?.tradeMedalLevel }})
          </div>
        </div>
        <div class="product-item-hover-cell">
          <div>
            Quality Experience
          </div>
          <div class="product-item-hover-cell__divider" />
          <div>
            ({{ item?.sellerDataInfo?.offerExperienceScore }})
          </div>
        </div>
        <div class="product-item-hover-cell">
          <div>
            Composite Service
          </div>
          <div class="product-item-hover-cell__divider" />
          <div>
            ({{ item?.sellerDataInfo?.compositeServiceScore }})
          </div>
        </div>
        <div class="product-item-hover-cell">
          <div>
            Dispute Complaint
          </div>
          <div class="product-item-hover-cell__divider" />
          <div>
            ({{ item?.sellerDataInfo?.disputeComplaintScore }})
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useStore } from 'vuex'
import { Image } from '@/components/Image'
import {
  buriedPointUtil,
  openURLWithChannelQuery,
  bankersRound,
  formatSalesVolume
} from '@/utils/utils'
import Rate from './Rate.vue'
import { Icon } from '@/components/Icon'
import { useGoogleImageTranslate } from '@/hooks/useGoogleImageTranslate'
import { IntlCurrency } from '@/components/NewIntlCurrency'

const store = useStore()
const { translate } = useGoogleImageTranslate()

const emits = defineEmits('onClick')

const props = defineProps({
  item: {
    type: Object,
    required: true
  }
})

const currencyData = computed(() => store.state.currencyData)

const productPrice = computed(() => (item) => {
  if (item) {
    const price = item?.priceInfo?.price || 0
    const rate = item?.priceInfo?.rate || currencyData?.value?.rate || 1
    return bankersRound(price * rate, 2)
  } else {
    return ''
  }
})

const addingCount = computed(() => {
  return Math.floor(Math.random() * (50 - 10 + 1)) + 10
})

const showUnderShipping = computed(() => {
  const item = props.item
  if (!item.sellerDataInfo || !item.monthSold) return false

  const repeatPurchasePercent = (item.sellerDataInfo.repeatPurchasePercent * 100).toFixed(0)
  return item.monthSold > 200 && repeatPurchasePercent > 50 && [3, 5, 7, 8].includes(item.monthSold % 10)
})

// 找相似
const findSimilar = async (item, e) => {
  e.stopPropagation()
  buriedPointUtil({ eventId: 'POP201' })
  sessionStorage.setItem(`currentMainImage_${item.offerId}`, item.imageUrl)
  openURLWithChannelQuery(`/search?offerId=${item.offerId}&type=similar`)
}

const handleClick = () => {
  emits('onClick', {
    ...props.item,
    addingCount: addingCount.value
  })
}

// 找样式一致
// const aiDiscovery = async (item, e) => {
//   e.stopPropagation()
//   buriedPointUtil({ eventId: 'POP202' })
//   sessionStorage.setItem(`currentMainImage_${item.offerId}`, item.imageUrl)
//   openURLWithChannelQuery(`/search?offerId=${item.offerId}&type=discovery`)
// }

// 翻译
const translateFun = async (item, e) => {
  e.stopPropagation()
  buriedPointUtil({ eventId: 'PTR201' })
  const complete = localStorage.getItem('complete') || ''

  if (complete.indexOf(4) === -1) {
    console.log(item, ';')
    store.dispatch('common/openGuidancePop', { id: 4, helpCenterImage: 'https://cdn-image.bestdealer.com/app-bestdealer/1688/guide-image-2.webp' })
    return
  }

  translate(item.imageUrl, item.subjectTrans)
}

const showMainHover = (item) => {
  const sellerDataInfo = item.sellerDataInfo || {}
  const tradeMedalLevel = sellerDataInfo.tradeMedalLevel || 0
  const offerExperienceScore = sellerDataInfo.offerExperienceScore || 0
  const compositeServiceScore = sellerDataInfo.compositeServiceScore || 0
  const disputeComplaintScore = sellerDataInfo.disputeComplaintScore || 0

  // 判断值为0的数量
  const zeroCount = [tradeMedalLevel, offerExperienceScore, compositeServiceScore, disputeComplaintScore].filter(item => Number(item) === 0).length
  if (zeroCount >= 2) {
    return false
  }
  return true
}
</script>
<style lang="less" scoped>
@import "./index.less";
</style>
